
import Button from '../base/Button';

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Ledger Linc
            </div>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#features" className="text-gray-600 hover:text-blue-600 cursor-pointer transition-colors">Features</a>
            <a href="#integrations" className="text-gray-600 hover:text-blue-600 cursor-pointer transition-colors">Integrations</a>
            <a href="#pricing" className="text-gray-600 hover:text-blue-600 cursor-pointer transition-colors">Pricing</a>
            <a href="#demo" className="text-gray-600 hover:text-blue-600 cursor-pointer transition-colors">Demo</a>
          </nav>
          
          <div className="flex items-center space-x-4">
            <Button variant="outline" size="sm">Sign In</Button>
            <Button size="sm">Start Free Trial</Button>
          </div>
        </div>
      </div>
    </header>
  );
}
